import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    default: String
  }

  connect() {
    const defaultPanel = this.defaultValue || this.panelTargets[0]?.dataset.panel || "content"
    this.showPanel(defaultPanel)
  }

  switch(event) {
    const button = event.currentTarget
    const panelId = button.dataset.tabPanel
    this.showPanel(panelId)
  }

  showPanel(panelId) {
    const tabGroup = this.element.dataset.tabsGroup

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tabPanel === panelId
      tab.classList.toggle("border-blue-500", isActive)
      tab.classList.toggle("text-blue-600", isActive)
      tab.classList.toggle("dark:text-blue-500", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-gray-500", !isActive)
      tab.classList.toggle("dark:text-gray-400", !isActive)
    })

    this.panelTargets.forEach(panel => {
      if (panel.dataset.tabsGroup === tabGroup) {
        const isVisible = panel.dataset.panel === panelId
        panel.classList.toggle("hidden", !isVisible)
      }
    })
  }
} 